import { urlFormatter } from "sb-resp-utils";
export var mapLinkUrl = function (ajustLive, ajustPreLive, x) {
    x.linkUrl = "";
    var url = urlFormatter.getEventUrl(x);
    if (x.isLive) {
        x.linkUrl = ajustLive(url);
    }
    else {
        x.linkUrl = ajustPreLive(url);
    }
    return x;
};
//# sourceMappingURL=mapLinkURL.js.map